import React from "react"
import styled from "styled-components"
import ProductCard from "../PLP/ProductCard"
import breakpoints from "../../styles/breakpoints"
import { getProductLink } from "../../services/product/link"
import Header from "../PLP/Header"
import { Link } from "gatsby"
import { GatsbyImage } from "gatsby-plugin-image"

const HeaderDiv = styled.div`
   width: 100%;
  margin: 0 auto;
  margin-bottom: 2em;
  padding-bottom: 10px;
  @media (max-width: ${breakpoints.md}){

    padding-bottom: auto;
    margin-bottom: auto;
  }

`

const ImagesGrid = styled.div`

  display: grid;
  gap: 1rem;
  margin: 1rem auto;
  max-width: 355px;
  @media (min-width: ${breakpoints.md}) {
    max-width: 1024px;
    grid-template-columns: ${(props) =>
      props.active ? "repeat(2, 1fr)" : "1fr"};
  }
`

const ImageContainer = styled.div`
  width: 100%;
  div {
    min-width: 100%;
  }
`


const HeaderImage = styled.div`
  width: 100%;
  background-image: url(${props => props.desktopURL ? props.desktopURL : ""});
  height: 271px;
  background-repeat: no-repeat;
  margin: 0 auto;
  background-position: center;
  background-size: contain;
  ${'' /* @media (max-width: 1156px){ 
    background-size: cover;

  } */}

  ${'' /* @media (min-width: 1058px)
  {
    background-size: cover;
    height: auto;
  } */}

  @media (max-width: ${breakpoints.md}){
    ${'' /* height: 219px; */}
    width: 100%;
    background-repeat: no-repeat;
    height: 165px;
    background-position: center;
    background-size: contain;
    background-image: url(${props => props.mobileURL ? props.mobileURL : ""});
  }
  


`

const ContentContainer = styled.div`
  padding-top: 0px;
  max-width: ${breakpoints.max};
  margin: auto;
`

const StyledGrid = styled.div`
  padding: auto;
  margin-bottom: 2em;
  display: grid;
  gap: 15px;
  grid-template-columns: repeat(2, 1fr);

  @media (min-width: ${breakpoints.sm}) {
    grid-template-columns: repeat(2, 1fr);
    grid-column-gap: 3vw;
    grid-row-gap: 5vw;
    gap: 30px;
    padding: 0px 6vw;
  }
  @media (min-width: ${breakpoints.md}) {
    padding: 0px 6vw;
    grid-template-columns: repeat(3, 1fr);
    gap: 30px;
    padding: 0px 6vw;
  }
`

const ProductLandingPageBlock = (props) => {
  const vegetarianIcon = props.data.contentfulShopPage.vegetarianIcon
  const glutenIcon = props.data.contentfulShopPage.glutenIcon

  let products = props.data.allSwellProduct.edges
  let contentfulProducts = props.data.allContentfulProduct.edges
  let productMap = {}
// Iterate over contentfulProducts and extract relevant data
for (const contentfulProduct of contentfulProducts) {
  let newObj = {};
  const node = contentfulProduct.node;

  newObj.title = node.title;
  newObj.hasVegetarian = node.hasVegetarian || false;
  newObj.isGlutenFree = node.isGlutenFree || false;

  // Get restaurant name from blocks
  const restaurantBlock = node.blocks?.find(
    (x) => x.__typename === "ContentfulRestaurant"
  );
  newObj.restaurant = restaurantBlock ? restaurantBlock.name : "";

  newObj.servingSize = node.servingSize || 2.5;
  newObj.newRelease = node.newRelease || false;
  newObj.quickCook = node.quickCook || false;
  newObj.spicy = node.spicy || 0;

  productMap[node.slug] = newObj;
}

// Map products to a new array with additional properties
products = products.map((x) => {
  const productData = productMap[x.node.slug] || {};
  return {
    node: {
      ...x.node,
      spicy: productData.spicy || 0,
      quickCook: productData.quickCook || false,
      newRelease: productData.newRelease || false,
      servingSize: productData.servingSize || 2.5,
      restaurant: productData.restaurant || "",
      isGlutenFree: productData.isGlutenFree || false,
      hasVegetarian: productData.hasVegetarian || false,
      contentfulTitle: productData.title || x.node.name,
    },
  };
});

  let addOnProducts = products
  let previousMealsProducts = products
  const collection = props.data.contentfulShopPage.collection
  const addOnCollection = props.data.contentfulShopPage.addOnCollection ?? []
  const previousMealsCollection =
    props.data.contentfulShopPage.previousMealsCollection ?? []

  products = collection
    ? products.filter((product) => {
        const productCategoryHandles = product.node.categories.map(
          (category) => category.slug
        )

        const included = productCategoryHandles.includes(collection.slug)

        return included ? product : null
      })
    : []

  addOnProducts = addOnCollection
    ? addOnProducts.filter((product) => {
        const productCategoryHandles = product.node.categories.map(
          (category) => category.slug
        )

        const included = productCategoryHandles.includes(addOnCollection.slug)

        return included ? product : null
      })
    : []

  previousMealsProducts = previousMealsCollection
    ? previousMealsProducts.filter((product) => {
        const productCategoryHandles = product.node.categories.map(
          (category) => category.slug
        )

        const included = productCategoryHandles.includes(
          previousMealsCollection.slug
        )

        return included ? product : null
      })
    : []
console.log(props.data.contentfulShopPage)
  return (
    <ContentContainer>
      {collection && (
        <>
        { props.data.contentfulShopPage.collection.desktopHeaderImage ?
        <> 
        <HeaderDiv >
        <a target={"_blank"} href={props.data.contentfulShopPage.collection.headerLink}>
          <HeaderImage desktopURL={props.data.contentfulShopPage.collection.desktopHeaderImage.file.url} mobileURL={props.data.contentfulShopPage.collection.mobileHeaderImage.file.url}/> 
          </a>
          {collection.images && (
        <ImagesGrid active={collection.images.length > 1 ? 1 : 0}>
          { collection.images.map((image, index) => {
            return (
              <ImageContainer key={index}>
                {index === 1 ? (
                  <Link to="/faqs">
                    <GatsbyImage
                      image={image.gatsbyImageData}
                      alt={image.title || ""}
                    />
                  </Link>
                ) : (
                  <GatsbyImage
                    image={image.gatsbyImageData}
                    alt={image.title || ""}
                  />
                )}
              </ImageContainer>
            )
          })}
        </ImagesGrid>
      )}
        </HeaderDiv> 
     
</>
         :  
        <Header noTitle={true} {...collection} />  //TURN THIS BACK ON AFTER NEXT DROP OPENS! 
          
           
        }
         
          <StyledGrid>
            {products.map((product, index) => {
              const {
                images,
                name,
                price,
                sale_price,
                sale,
                slug,
                currency,
                stock_level,
                stock_status,
                options,
                contentfulTitle,
                hasVegetarian,
                isGlutenFree,
                restaurant,
                servingSize,
                newRelease,
                quickCook,
                spicy,
              } = product.node
              return (
                <ProductCard
                  gatsbyImageData={
                    images[0]?.fileLocal?.childImageSharp?.gatsbyImageData
                  }
                  gatsbyImageDataAlternate={
                    images[1]?.fileLocal?.childImageSharp?.gatsbyImageData
                  }
                  price={price}
                  sale_price={sale_price}
                  sale={sale}
                  name={contentfulTitle} //{name}
                  path={getProductLink(slug)}
                  currency={currency}
                  stock_status={stock_status}
                  stock_level={stock_level}
                  hasVegetarian={hasVegetarian}
                  isGlutenFree={isGlutenFree}
                  restaurant={restaurant}
                  options={options}
                  servingSize={servingSize}
                  newRelease={newRelease}
                  quickCook={quickCook}
                  spicy={spicy}
                  vegetarianIcon={vegetarianIcon}
                  glutenIcon={glutenIcon}
                  key={index}
                />
              )
            })}
          </StyledGrid>
        </>
      )}
      {addOnCollection && (
        <>
          <Header {...addOnCollection} />
          <StyledGrid>
            {addOnProducts.map((product, index) => {
              const {
                images,
                name,
                price,
                sale_price,
                sale,
                slug,
                currency,
                stock_level,
                stock_status,
                options,
                contentfulTitle,
                hasVegetarian,
                isGlutenFree,
                restaurant,
                servingSize,
                newRelease,
                quickCook,
                spicy,
              } = product.node
              return (
                <ProductCard
                  addOn={true}
                  gatsbyImageData={
                    images[0]?.fileLocal?.childImageSharp?.gatsbyImageData
                  }
                  gatsbyImageDataAlternate={
                    images[1]?.fileLocal?.childImageSharp?.gatsbyImageData
                  }
                  price={price}
                  sale_price={sale_price}
                  sale={sale}
                  name={contentfulTitle} //{name}
                  path={getProductLink(slug)}
                  currency={currency}
                  stock_status={stock_status}
                  stock_level={stock_level}
                  hasVegetarian={hasVegetarian}
                  isGlutenFree={isGlutenFree}
                  restaurant={restaurant}
                  options={options}
                  servingSize={servingSize}
                  newRelease={newRelease}
                  quickCook={quickCook}
                  spicy={spicy}
                  vegetarianIcon={vegetarianIcon}
                  glutenIcon={glutenIcon}
                  key={index}
                />
              )
            })}
          </StyledGrid>
        </>
      )}
      {previousMealsCollection && (
        <>
          <Header {...previousMealsCollection} />
          <StyledGrid>
            {previousMealsProducts.map((product, index) => {
              const {
                images,
                name,
                price,
                sale_price,
                sale,
                slug,
                currency,
                stock_level,
                stock_status,
                options,
                contentfulTitle,
                hasVegetarian,
                isGlutenFree,
                restaurant,
                servingSize,
                newRelease,
                quickCook,
                spicy,
              } = product.node
              return (
                <ProductCard
                  gatsbyImageData={
                    images[0].fileLocal?.childImageSharp.gatsbyImageData
                  }
                  gatsbyImageDataAlternate={
                    images[1]?.fileLocal?.childImageSharp.gatsbyImageData
                  }
                  price={price}
                  sale_price={sale_price}
                  sale={sale}
                  name={contentfulTitle} //{name}
                  path={getProductLink(slug)}
                  currency={currency}
                  stock_status={stock_status}
                  stock_level={stock_level}
                  hasVegetarian={hasVegetarian}
                  isGlutenFree={isGlutenFree}
                  restaurant={restaurant}
                  options={options}
                  servingSize={servingSize}
                  newRelease={newRelease}
                  quickCook={quickCook}
                  spicy={spicy}
                  vegetarianIcon={vegetarianIcon}
                  glutenIcon={glutenIcon}
                  key={index}
                />
              )
            })}
          </StyledGrid>
        </>
      )}
    </ContentContainer>
  )
}

export default ProductLandingPageBlock
